<template>
    <div>
      <ToastAlert :is-active="toastAlert" :type="typeMsg" :message="msg" />
      <div class="flex min-h-screen bg-dark_bg-100 text-white h-full">
        <div class="w-1/2 flex items-center justify-center">
          <div class="mt-20">
            <img
              src="@/assets/imgs/door.jpg"
              alt="Tuin hora de hacer magia"
              class="w-full h-full max-h-screen rounded-lg shadow-lg"
            />
          </div>
        </div>
  
        <!-- Formulario para Cambiar Contraseña -->
        <div class="w-full sm:w-1/2 flex flex-col items-center justify-center bg-black min-h-screen">
          <img
            src="@/assets/imgs/LogoTuin.svg"
            alt="Logo"
            class="object-contain"
          />
          <h3 class="mb-6">Gabi</h3>
          
          <!-- card -->
          <div class="w-3/4 max-w-md bg-dark_bg-100 p-5 rounded-sm">
            <h2 class="text-2xl font-semibold mb-6">Cambia tu contraseña</h2>
            
            <!-- Campo para nueva contraseña -->
            <div class="mb-4">
              <fwb-input
                v-model="newPassword"
                label="Nueva Contraseña"
                type="password"
                required=""
                label-class="text-white"
                placeholder="Ingrese su nueva contraseña"
                class="custom-label"
              />
            </div>
            
            <!-- Campo para confirmar nueva contraseña -->
            <div class="mb-4">
              <fwb-input
                v-model="confirmPassword"
                label="Confirmar Contraseña"
                type="password"
                required=""
                label-class="text-white"
                placeholder="Confirme su nueva contraseña"
                class="custom-label"
              />
            </div>
            
            <!-- Botón para enviar nueva contraseña -->
            <button
              class="w-full py-2 bg-tuin-100 hover:bg-tuin-100 rounded-md text-white font-semibold"
              @click="changePassword"
            >
              Cambiar Contraseña
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>

import { FwbInput } from "flowbite-vue";
import axios from "axios";
import ToastAlert from "@/commond/ToastAlert.vue";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted } from "vue";




const router = useRouter();
const route = useRoute();
const token = ref("");

// Captura el token cuando el componente esté montado
onMounted(() => {
  token.value = route.params.token_temp; // Cambia 'token' por 'token_temp'
  console.log("Token capturado desde la URL:", token.value);
});

const newPassword = ref("");
const confirmPassword = ref("");
const toastAlert = ref(false);
const typeMsg = ref("");
const msg = ref("");

async function changePassword() {
  if (newPassword.value === "" || confirmPassword.value === "") {
    showToast('danger', 'Todos los campos son obligatorios');
    return false;
  }

  if (newPassword.value.length < 8) {
    showToast('danger', 'La contraseña debe tener al menos 8 caracteres');
    return false;
  }

  if (newPassword.value !== confirmPassword.value) {
    showToast('danger', 'Las contraseñas no coinciden');
    return false;
  }

  // Parámetros a enviar en la solicitud
  let params = {
    token: token.value,  // Usa el token capturado
    password: newPassword.value
  };

  console.log("Parámetros a enviar:", params);

  try {
    // Realiza la solicitud para actualizar la contraseña
    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/update_password_account`,
      params
    );

    console.log("Respuesta completa:", response);

    // Si la respuesta es exitosa, mostrar mensaje y redirigir
    if (response.status === 200) {
      showToast('success', 'Contraseña cambiada exitosamente');
      setTimeout(() => {
        router.push({ name: "login" });
      }, 2000);
    }
  } catch (error) {
    // Manejo de errores en la solicitud
    console.log("Error en la solicitud:", error); // Log para el error completo
    if (error.response && error.response.status === 422) {
      showToast('danger', 'Hubo un problema al cambiar la contraseña');
    } else {
      showToast('danger', 'Error de servidor, intente más tarde');
    }
  }
}

async function showToast(type = null, message = null) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}
</script>

<style scoped>
::v-deep .custom-label label {
  @apply text-white;
}

::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
  @apply text-white;
}
</style>

